import { render, staticRenderFns } from "./num2.vue?vue&type=template&id=40c40d70&"
import script from "./num2.vue?vue&type=script&lang=js&"
export * from "./num2.vue?vue&type=script&lang=js&"
import style0 from "./num2.vue?vue&type=style&index=0&id=40c40d70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports